define('ordersDetailOrderProductStockView',[
  'module',
  'backbone',
  'marionette',
  'underscore',
  'settings',
  'windows',
  'ordersDetailOrderProductStockListView',
  'ordersDetailOrderProductStockItemView',
  'template!ordersDetailOrderProductStockView'
], function (
  Module,
  Backbone,
  Marionette,
  _,  
  Settings,
  Windows,
  ListView,
  ItemView,
  Tpl
) {
  'use strict';   

  Module.exports = Marionette.CompositeView.extend({
    template: Tpl,
    childView: ItemView,
    className: 'orders-detail-order-product-stock-view',
    childViewContainer: '.items-container',

    childViewOptions: function() {
      return {
        product: this.model
      };
    },

    ui: { 
      listIcon: '.list-icon',   
      checkStockWarning: '.check-stock-warning'   
    },

    events: {
      'click @ui.listIcon': 'onOpenList' 
    },

    modelEvents: {
      'change:quantity': 'render'
    },

    initialize: function() {
      this.collection = new Backbone.Collection();
    },

    onRender: function() {
      this.collection.reset();

      this.fetch().done(_.bind(function(data) {
        if (this.isDestroyed)
          return;
        
        var selectedItem = '';

        if(this.model.get('optionsMix') && this.model.get('optionsMix').length > 0) {  
          this.model.get('optionsMix').forEach(function (mixableOption) {
            selectedItem = '';
            _.each(data, function (item) {
              if(item.code === mixableOption.productCodeVariation && !selectedItem)
                selectedItem = item;                    
            }, this);

            if(selectedItem) 
              this.collection.add({
                stockQuantity: selectedItem.currentQuantity,
                orderQuantity: mixableOption.quantity,
                newArrivalQuantity: selectedItem.newArrivalQuantity,
                newArrivalETA: selectedItem.newArrivalETA,
                productOptions: selectedItem.productOptions
              });                
          }, this);
        } else {          
          selectedItem = '';
          _.each(data, function (item) {
            if(item.code === this.model.get('productCode') && !selectedItem)
              selectedItem = item;            
          }, this);
          if(selectedItem) 
            this.collection.add({
                stockQuantity: selectedItem.currentQuantity,
                orderQuantity: this.model.get('quantity'),
                newArrivalQuantity: selectedItem.newArrivalQuantity,
                newArrivalETA: selectedItem.newArrivalETA,
                productOptions: selectedItem.productOptions
              }); 
        }      
          
        this.ui.checkStockWarning.hide();
             
      }, this)).fail(_.bind(function() {
        if (this.isDestroyed)
          return;
        this.ui.checkStockWarning.css('display', 'flex');  
      }, this));
    },

    fetch: function() {
      var defer = $.Deferred(), url;       

      if (this.options.product.get('pim'))
        url = Settings.url('compuzz2', 'v2/pim/products/resellerProduct/' + this.options.product.get('secId') + '/stocks');
      else
        url = Settings.url('compuzz2', 'products.json/' + this.options.product.get('secId') + '/stocks');

      $.ajax({
        type: 'GET',
        url: url,
        success: function (data) {
          defer.resolve(data);
        },
        error: function () {
          defer.reject();
        }
      });
      return defer.promise();
    },

    onOpenList: function() {
      Windows.open({
        view: _.bind(function () {
          return new ListView({
            secId: this.options.product.get('secId'),
            pim: this.options.product.get('pim'),
            productCode: this.model.get('productCode'),
            productOwner: this.model.get('productOwner'),
            caccountName: this.options.caccountName
          });
        }, this),
        id: 'order.product.stock:' + this.options.product.get('secId'),
        title: _.i18n('common.stock') + ': ' + this.model.get('productCode'),
        width: 1024,
        height: 600,
        minWidth: 600,
        minHeight: 400
      });
    }
  });
});

